import gql from 'graphql-tag';
import { BookingsFragmentInclude } from './Bookings';

export default gql`
    fragment OtherMusicians on Funeral {
        OtherMusicians {
            ${BookingsFragmentInclude}
        }
    }
`;
